module.exports = __webpack_public_path__ + "assets/img/front.d873e5c4.png";